module.exports = "<div class=\"card no-margin\">\n  <h1>Welcome {{authUser.sub}} </h1>\n  <p>You have 0 unread messages since your last login</p>\n</div>\n"